/**
 * Persists the pipeline used for the most recently created deal so the New Deal
 * surfaces (quick-create dialog + full create page) pre-select it next time.
 *
 * Stored client-side in localStorage, keyed by tenant+user for multi-tenant
 * safety — this is a trivial per-user UX default, not data worth a backend table.
 * Mirrors the keying convention of useSetupGuideState.
 */
const STORAGE_PREFIX = 'panluma_pipeline_last_used_';

export function lastUsedPipelineStorageKey(tenantId: string, userId: string): string {
  return `${STORAGE_PREFIX}${tenantId}_${userId}`;
}

export function getLastUsedPipelineId(tenantId: string, userId: string): string | null {
  try {
    return localStorage.getItem(lastUsedPipelineStorageKey(tenantId, userId));
  } catch {
    // Ignore storage errors (quota, private mode)
    return null;
  }
}

export function setLastUsedPipelineId(
  tenantId: string,
  userId: string,
  pipelineId: string,
): void {
  try {
    localStorage.setItem(lastUsedPipelineStorageKey(tenantId, userId), pipelineId);
  } catch {
    // Ignore storage errors (quota, private mode)
  }
}
